/* eslint-disable pii/no-phone-number */
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  subject: Yup.string().required('Insira um assunto'),
  message: Yup.string().required('Insira sua mensagem'),
});
